import React from 'react';

const Footer = () => {
  return(
    <section className="hero-foot">
      <nav className="tabs is-boxed is-fullwidth">
        <div className="link-container">
          <ul>
            <li className="">
              <a>Overview</a>
            </li>
            <li>
              <a>Contact</a>
            </li>
            <li>
              <a>About</a>
            </li>
            <li>
              <a>GitHub</a>
            </li>
            <li>
              <a>LinkedIn</a>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  );
};

export default Footer;